module.exports = __webpack_public_path__ + "img/Facturenoverzicht.e6f43329.png";